/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

const styles = {
  prettyLineBreak: css`
    display: inline-block;
    text-wrap: balance;
    text-wrap: pretty;
  `,
};

/**
 * TextWrapper
 *
 * Applies `text-wrap: pretty and balance` to its child content to improve text wrapping and readability using an experimental style with a fallback.
 * This component is used for experimentation purposes.
 *
 * @param {object} props
 * @param {React.ReactNode} props.children - The content to be wrapped.
 * @returns {JSX.Element}
 *
 * @remarks
 * This component is intended for experimental use. Feel free to modify or remove it as needed.
 */

const TextWrapper = ({ children }: { children: React.ReactNode }) => {
  return <span css={styles.prettyLineBreak}>{children}</span>;
};

export default TextWrapper;
